import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { ContributionsDisDialogComponent } from '../contributions-dis-dialog/contributions-dis-dialog.component';
import { ManagerSelectionDialogComponent } from '../manager-selection-dialog/manager-selection-dialog.component';
import { ContributionsDisDeclineDialogComponent } from '../contributions-dis-cancel-dialog/contributions-dis-cancel-dialog.component';
import { ContributionsDisPreviewDialogComponent } from '../contributions-dis-preview-dialog/contributions-dis-preview-dialog.component';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { AttachedContributionsDisUploadDialogComponent } from '../attached-contributions-dis-upload-dialog/attached-contributions-dis-upload-dialog.component';
import {
  AportacionDIEstadoControllerService,
  AportacionDIEstadoDTO,
  AdheridoControllerService,
  BusquedaAdheridoDTO,
  AportacionDiAdheridoControllerService,
  AportacionDIAdheridoFilterDTO,
  PlataformaOrigenControllerService, PlataformaOrigenDTO,
  GestionResiduosFilterDTO,
  GestoresResiduosEstadosControllerService,
  CodigoLerControllerService,
  CodigoLerFilterDTO,
  OperacionGestionControllerService,
  DiccionarioElementoDTO,
  DiccionarioControllerService
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import moment from 'moment';
import {ValidateService} from "../../../services/validate.service";
import { AttachedService } from '../../../services/attached.service';
import { AdheridoFilterDTO } from '../../../../../../dist/api-rest/api-adheridos/model/adheridoFilterDTO';
@Component({
  selector: 'app-contributions-dis',
  templateUrl: './contributions-dis.component.html',
  styleUrls: ['./contributions-dis.component.scss'],
})
export class ContributionsDisComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  totalKilos: number | undefined;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  nimaPoseedorArray: any[] = [];
  nimaGestorArray: any[] = [];
  globalIdPoseedores: any[] = [];
  adheridoArray: any[] = [];
  estadoArray: any[] = [];
  plataformaOrigenArray: any[] = [];
  headArray: any = [
    {
      Head: 'ID Adh.',
      FieldName: 'adherido',
      Attribute: 'id',
      tooltipHeader: 'ID ADHERIDO',
    },
    {
      Head: 'Adherido',
      FieldName: 'adherido',
      Attribute: 'razonSocial',
      tooltipHeader: 'RAZÓN SOCIAL DEL ADHERIDO',
    }, 
    {
      Head: 'Documento',
      FieldName: 'adherido',
      Attribute: 'codigoDocumento',
      tooltipHeader: 'DOCUMENTO DEL ADHERIDO (NIF, NIE)',
    },
    {
      Head: 'NIMA Ges.',
      FieldName: 'gestorResiduo',
      tooltipHeader: 'NIMA DEL GESTOR',
      renderValue: (item: any) => item?.gestorResiduo ? item?.gestorResiduo.nima : item?.nimaGestor,
    },
    {
      Head: 'Fecha de aport.',
      FieldName: 'fechaMAportacion',
      tooltipHeader: 'FECHA APORTACIÓN',
    },
    {
      Head: 'Fecha de acep.',
      FieldName: 'fechaMAceptacion',
      tooltipHeader: 'FECHA ACEPTACIÓN',
    },
    {
      Head: 'DI/FS',
      FieldName: 'documentoIdentificacion',
      tooltipHeader: 'DOC. IDENTIFICACIÓN/FULL SEGUIMENT',
    },
    {
      Head: 'Cód. LER y descrip.',
      FieldName: 'descripcionMCodLer',
      tooltipHeader: 'CÓDIGO LER Y DESCRIPCIÓN',
      Maxtext: 25,
      Tooltip: true,
    },
    {
      Head: 'Op. Ges.',
      FieldName: 'descripcionOperacionGes',
      tooltipHeader: 'OPERACIÓN DE GESTIÓN',
      Maxtext: 25,
      Tooltip: true,
    },
    {
      Head: 'Cant Kg',
      FieldName: 'cantidadGestionada',
      tooltipHeader: 'CANTIDAD NETA GESTIONADA (KG)',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.cantidadGestionada),
    },
    {
      Head: 'Est. aport.',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
      tooltipHeader: 'ESTADO APORTACIÓN',
    },
    {
      Head: 'Plat. origen',
      FieldName: 'plataformaOrigen',
      Attribute: 'descripcion',
      tooltipHeader: 'PLATAFORMA ORIGEN',
    },
    {
      Head: 'Est. adh.',
      FieldName: 'adherido',
      tooltipHeader: 'ESTADO ADHERIDO',
      renderValue: (item: any) => {
        const estadoId = item?.adherido?.estado?.id ?? item?.adherido?.estado;
        const estadoObj = this.estadoArrayAdherido?.find((e: any) => e.id == estadoId);
        return (
          estadoObj?.descripcion_corta ??
          estadoObj?.descripcionCorta ??
          estadoObj?.descripcion ??
          ''
        );
      },
    },
    {
      Head: 'Acc',
      FieldName: 'actions',
      tooltipHeader: 'ACCIONES',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar',
          show: {
            params: 'canAccessDelete',
            accion: 'delete',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'preview',
              name: 'Vista previa',
              show: { params: 'canAccessPreview', accion: 'preview' },
            },
            {
              nameButton: 'send',
              name: 'Enviar aportación ',
              show: {
                params: 'canAccessSend',
                accion: 'send',
              },
            },
            {
              nameButton: 'accept',
              name: 'Aceptar aportación',
              show: { params: 'canAccessAccept', accion: 'accept' },
            },
            {
              nameButton: 'cancel',
              name: 'Cancelar aportación',
              show: { params: 'canAccessCancel', accion: 'cancel' },
            },
                        { 
              nameButton: 'correccionEnvalora',
              name: 'Corrección Envalora',
              show: { params: 'canAccessCorreccionEnvalora', accion: 'correccionEnvalora' },
            },
          ],
        },
      ],
      width: '15',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;

  updateList: boolean = false;
  adheridoEndpoint: string =
    this.environment.urlBackAdheridos + 'api/v1/adheridos/adheridos';
  defaultAdheridosParameters = { 'declaracionFacturada': true };
  defaultSort: string = 'id,desc';
  currentSort: string = '';

  rolesGestor: any[] = [];
  rolesAdherido: any[] = [];
  gestoresArray: any[] = [];
  estadoGestorArray: any[] = [];
  codigoDocumentoAdheridoArray: any[] = []
  estadoArrayAdherido: any[] = [];
  codigoLerArray: any[] = [];
  operacionGestionArray: any[] = [];
  mostrarFiltros: boolean = true;

  listaGestores = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos';
  defaultGestoresParameters = { 'gestorResiduos': true, 'gestoresResiduosEstado.id': [1,2, 3] };


  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private aportacionDiAdheridoControllerService: AportacionDiAdheridoControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private adheridoControllerService: AdheridoControllerService,
    private AportacionDIEstadoControllerService: AportacionDIEstadoControllerService,
    private validateSrv: ValidateService,
    private plataformaOrigenControllerService: PlataformaOrigenControllerService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private attachedService: AttachedService,
    private gestorEstadoControllerService: GestoresResiduosEstadosControllerService,
    private codigoLerControllerService: CodigoLerControllerService,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    const fechadesde = `01/01/${moment().format('YYYY')}`;
    const [dia, mes, año] = fechadesde.split('/').map(Number);
    const fechaInicialDesde = new Date(año, mes - 1, dia);

    const fechaActual = new Date();

    this.searchForm = this.formBuilder.group({
      adherido: [{ value: null, disabled: false }],
      gestor: [{ value: null, disabled: false }],
      idAdherido: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      codigo_documento: [{ value: null, disabled: false }, Validators.maxLength(255)],
      codigo_documento_gestor: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }, Validators.maxLength(255)],
      nima_gestor: [{ value: null, disabled: false },
        Validators.compose([
          Validators.pattern(this.validateSrv.nimaPattern),
          Validators.maxLength(10)
        ])],
      fecha_desde: [
        { value: fechaInicialDesde, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_hasta: [
        { value: fechaActual, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_aport_desde: [
        { value: null, disabled: false },
      ],
      fecha_aport_hasta: [
        { value: null, disabled: false },
      ],

      doc_identificacion: [{ value: null, disabled: false }, [Validators.minLength(6), Validators.maxLength(255)]],
      estado: [{ value: null, disabled: false }],
      fechaAceptacion: [{ value: null, disabled: false }],
      plataformaOrigen: [{ value: null, disabled: false }],
      estadoAdherido: [{ value: null, disabled: false }],
      estadoGestor: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
      operacionGestion: [{ value: null, disabled: false }],
            orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.comboEstados();
    this.getAdheridos();
    this.comboPlataformaOrigen();
    this.comboEstadosAdherido();
    this.comboEstadosGestor();
    this.comboCodigoLer();
    this.comboOperacionGestion();
    this.comboOrden();
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  private getBackendFilter() {
    const textFilter = (value: any) =>
      value?.trim() ? `ci(${value?.trim()})` : undefined;
    let formatDateDesde = moment(new Date(this.searchForm.get('fecha_desde')?.value)
    ).format('YYYY-MM-DD');

    formatDateDesde = `${formatDateDesde}`;

    let formatDateHasta = moment(
      new Date(this.searchForm.get('fecha_hasta')?.value)
    ).format('YYYY-MM-DD');

    formatDateHasta = `${formatDateHasta}`;

    //Fecha aportacion
    let fechaAportacion : string[] | undefined;
    if(this.searchForm.get('fecha_aport_desde')?.value || this.searchForm.get('fecha_aport_hasta')?.value){
      fechaAportacion = [];
      if(this.searchForm.get('fecha_aport_desde')?.value){
        let formatDateAportDesde = moment(
          new Date(this.searchForm.get('fecha_aport_desde')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportDesde = `${formatDateAportDesde}`;
        fechaAportacion.push(formatDateAportDesde);
      }
      if(this.searchForm.get('fecha_aport_hasta')?.value){
        let formatDateAportHasta = moment(
          new Date(this.searchForm.get('fecha_aport_hasta')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportHasta = `and(lte(${formatDateAportHasta}))`;
        fechaAportacion.push(formatDateAportHasta);
      }
    }

    const selectGestores = this.searchForm.get('gestor')?.value;

    let gestorFilter: GestionResiduosFilterDTO;
    if (selectGestores && selectGestores.length > 0) {
      gestorFilter = {
        id: selectGestores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    } else {
      gestorFilter = {
        codigoDocumento: this.searchForm.get('codigo_documento_gestor')?.value,
      }
    }

    const selectAdheridos = this.searchForm.get('adherido')?.value;
    let selectAdheridosId: any[] = [];
    if (selectAdheridos !== undefined && selectAdheridos !== null) {
      selectAdheridosId = selectAdheridos.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const idAdheridoValue = this.searchForm.get('idAdherido')?.value;
    if (idAdheridoValue) {
      selectAdheridosId.push(idAdheridoValue);
    }
    const selectEstadoAdherido = this.searchForm.get('estadoAdherido')?.value;
    let selectEstadosAdheridosId: any[] = [];
    if (selectEstadoAdherido !== undefined && selectEstadoAdherido !== null) {
      selectEstadosAdheridosId = selectEstadoAdherido.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const selectEstadoG = this.searchForm.get('estadoGestor')?.value;
    let selectEstadosIdG: any[] = [];
    if (selectEstadoG !== undefined && selectEstadoG !== null) {
      selectEstadosIdG = selectEstadoG.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    gestorFilter.gestoresResiduosEstado = {
      id: (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) && this.searchForm.get('estadoGestor')?.value ? selectEstadosIdG : undefined,
    }
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const selectCodigoLer = this.searchForm.get('codigoLer')?.value;
    let selectCodigoLerId: any[] = [];
    if (selectCodigoLer !== undefined && selectCodigoLer !== null) {
      selectCodigoLerId = selectCodigoLer.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const selectOperacionGestion = this.searchForm.get('operacionGestion')?.value;
    let selectOperacionGestionId: any[] = [];
    if (selectOperacionGestion !== undefined && selectOperacionGestion !== null) {
      selectOperacionGestionId = selectOperacionGestion.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    let backendFilter: any = {
      adherido: {
        id: selectAdheridosId,
        codigoDocumento: this.searchForm.get('codigo_documento')?.value ? this.searchForm.get('codigo_documento')?.value.trim() : undefined,
        estado :selectEstadosAdheridosId       // razonSocial: textFilter(this.searchForm.get('razon_social')?.value),
      },
      gestorResiduo: gestorFilter,
      fechaAceptacion: [formatDateDesde, formatDateHasta],
      fechaAportacion: fechaAportacion,
      documentoIdentificacion: this.searchForm.get('doc_identificacion')?.value ? this.searchForm.get('doc_identificacion')?.value.trim() : undefined,
      estado: {id: selectEstadosId},
      razonSocialAdherido: this.searchForm.get('razon_social')?.value,
      plataformaOrigen: this.searchForm.get('plataformaOrigen')?.value,
      codigoLer: { id: selectCodigoLerId },
      operacionGestion: { id: selectOperacionGestionId },
    };
    if(this.searchForm.get('nima_gestor')?.value){
      backendFilter.nimaGestor = selectGestores && selectGestores.length > 0 ? undefined : this.searchForm.get('nima_gestor')?.value;
    }
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const sort = this.currentSort != '' ? this.currentSort : this.defaultSort;
        const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, sort, orden, tipoOrden };
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.aportacionDiAdheridoControllerService
      .exportCSV3(backendFilter, 'response')
      .subscribe((res: any) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'ExportacionDi.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  getAdheridoDescription(obj: any) {
    return obj.razonSocial;
  }

  getAdheridoObjectQuery(searchterm: string) {
    return {
      razonSocial: `${searchterm}`,
      /*'estado.id': 6, */
    };
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
    this.currentSort = '';
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v: any) => {
          if (typeof v === 'object' && typeof filtro.value === 'object') {
            const currentId = v?.id ?? v;
            const targetId = filtro.value?.id ?? filtro.value;
            return currentId !== targetId;
          }
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    this.pageNumber = 0;
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const adheridos = this.searchForm.get('adherido')?.value as any[];
    if (adheridos?.length) {
      adheridos.forEach((adherido: any) => {
        const adheridoId = adherido?.id ?? adherido;
        const found = this.adheridoArray?.find((a: any) => a.id === adheridoId);
        filtros.push({
          label: adherido?.razonSocial ?? found?.razonSocial ?? `Adherido ${adheridoId}`,
          campo: 'adherido',
          value: adherido,
        });
      });
    }

    const gestores = this.searchForm.get('gestor')?.value as any[];
    if (gestores?.length) {
      gestores.forEach((gestor: any) => {
        const label = gestor?.razonSocial ? this.getGestorDescription(gestor) : String(gestor);
        filtros.push({ label, campo: 'gestor', value: gestor });
      });
    }

    const idAdherido = this.searchForm.get('idAdherido')?.value;
    if (idAdherido) filtros.push({ label: ` ${idAdherido}`, campo: 'idAdherido' });

    const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
    if (codigoDocumento?.trim()) filtros.push({ label: ` ${codigoDocumento.trim()}`, campo: 'codigo_documento' });

    const codigoDocumentoGestor = this.searchForm.get('codigo_documento_gestor')?.value;
    if (codigoDocumentoGestor?.trim()) filtros.push({ label: ` ${codigoDocumentoGestor.trim()}`, campo: 'codigo_documento_gestor' });

    const razonSocial = this.searchForm.get('razon_social')?.value;
    if (razonSocial?.trim()) filtros.push({ label: ` ${razonSocial.trim()}`, campo: 'razon_social' });

    const nimaGestor = this.searchForm.get('nima_gestor')?.value;
    if (nimaGestor?.trim()) filtros.push({ label: ` ${nimaGestor.trim()}`, campo: 'nima_gestor' });

    const fechaDesde = this.searchForm.get('fecha_desde')?.value;
    if (fechaDesde) filtros.push({ label: ` ${moment(new Date(fechaDesde)).format('DD/MM/YYYY')}`, campo: 'fecha_desde' });

    const fechaHasta = this.searchForm.get('fecha_hasta')?.value;
    if (fechaHasta) filtros.push({ label: ` ${moment(new Date(fechaHasta)).format('DD/MM/YYYY')}`, campo: 'fecha_hasta' });

    const fechaAportDesde = this.searchForm.get('fecha_aport_desde')?.value;
    if (fechaAportDesde) filtros.push({ label: ` ${moment(new Date(fechaAportDesde)).format('DD/MM/YYYY')}`, campo: 'fecha_aport_desde' });

    const fechaAportHasta = this.searchForm.get('fecha_aport_hasta')?.value;
    if (fechaAportHasta) filtros.push({ label: ` ${moment(new Date(fechaAportHasta)).format('DD/MM/YYYY')}`, campo: 'fecha_aport_hasta' });

    const docIdentificacion = this.searchForm.get('doc_identificacion')?.value;
    if (docIdentificacion?.trim()) filtros.push({ label: `${docIdentificacion.trim()}`, campo: 'doc_identificacion' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estado: any) => {
        filtros.push({
          label: `${estado?.descripcionCorta ?? String(estado)}`,
          campo: 'estado',
          value: estado,
        });
      });
    }

    const plataformaOrigen = this.searchForm.get('plataformaOrigen')?.value;
    if (plataformaOrigen) {
      filtros.push({
        label: ` ${plataformaOrigen?.descripcion ?? String(plataformaOrigen)}`,
        campo: 'plataformaOrigen',
      });
    }

    const estadoAdherido = this.searchForm.get('estadoAdherido')?.value as any[];
    if (estadoAdherido?.length) {
      estadoAdherido.forEach((estadoId: any) => {
        const found = this.estadoArrayAdherido.find((e: any) => e.id === estadoId);
        filtros.push({
          label: ` ${found?.descripcion_corta ?? found?.descripcionCorta ?? String(estadoId)}`,
          campo: 'estadoAdherido',
          value: estadoId,
        });
      });
    }

    const estadoGestor = this.searchForm.get('estadoGestor')?.value as any[];
    if (estadoGestor?.length) {
      estadoGestor.forEach((estado: any) => {
        filtros.push({
          label: ` ${estado?.descripcionCorta ?? String(estado)}`,
          campo: 'estadoGestor',
          value: estado,
        });
      });
    }

    const codigosLer = this.searchForm.get('codigoLer')?.value as any[];
    if (codigosLer?.length) {
      codigosLer.forEach((codigo: any) => {
        const label = codigo?.tipoCodigo
          ? `${codigo.tipoCodigo} ${codigo.descripcion ?? ''}`
          : String(codigo);
        filtros.push({ label, campo: 'codigoLer', value: codigo });
      });
    }

    const operaciones = this.searchForm.get('operacionGestion')?.value as any[];
    if (operaciones?.length) {
      operaciones.forEach((operacion: any) => {
        const label = operacion?.codigo
          ? `${operacion.codigo} ${operacion.descripcion ?? ''}`
          : String(operacion);
        filtros.push({ label, campo: 'operacionGestion', value: operacion });
      });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'adherido': {
        return this.searchForm.get('adherido') as FormControl;
      }
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  getGestorDescription(obj: any) {
    return obj?.razonSocial + ' - ' + obj?.nima + ' - ' + obj?.centro;
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: searchterm,
      'estado.id': 4,
    };
  }

  searchData(initPage:boolean = false) {
    if(initPage){
			this.pageNumber = 0;
		}
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }
    const { backendFilter, page, size, sort, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.aportacionDiAdheridoControllerService
      ?.findAllAportacionDIAdherido(backendFilter ?? {}, {
        page: page,
        size: size,
        sort: [sort],
      },
        orden,
        tipoOrden)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
    this.aportacionDiAdheridoControllerService.getTotalKilos(backendFilter).subscribe({
      next: (total) => { this.totalKilos = total; },
      error: () => { this.totalKilos = undefined; },
    });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalContributions(false, false, element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'send') {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAdheridoControllerService
        .actualizarEstado(element.id, 2)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha enviado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'accept') {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAdheridoControllerService
        .actualizarEstado(element.id, 3)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha aceptado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'cancel') {
      this.openModalMotivoCancel(element);
    }else if (element.nameButton == 'preview'){
      this.vistaPreviaAportacion(element.documento);
    }else if (element.nameButton == 'correccionEnvalora'){
      this.spinnerSrv.loadingShow();
      this.aportacionDiAdheridoControllerService
        .actualizarEstado(element.id, 10)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha actualizado el estado de la aportación a corrección Envalora correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    }
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la aportación DI/FS?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarDis(element);
      }
    });
  }

  eliminarDis(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAdheridoControllerService
        .deleteById6(element.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `La aportación Di/FS se ha eliminado correctamente`,
              'success'
            );
            this.gridArray = this.gridArray.filter(
              (objeto) => objeto.id !== element.id
            );
            this.flagSearch = this.gridArray.length != 0 ? true : false;
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  getAdheridos() {
    if (this.authService.user?.roleEntities?.length > 0) {
      const adheridosIds = this.authService.user?.roleEntities
        .filter((adheridoRol: any) => adheridoRol.type === 'ADHERIDO')
        .flatMap((adheridoRol: any) => {
          if(adheridoRol.entity == null || adheridoRol.entity == undefined){
            return [];
          }else if (Array.isArray(adheridoRol.entity)) {
            return adheridoRol.entity;
          } else {
            return [adheridoRol.entity];
          }
        });
      const filter: BusquedaAdheridoDTO = {
        id: adheridosIds,
        estado: [6],
        declaracionFacturada: true,
      };

      this.spinnerSrv.loadingShow();
      this.adheridoControllerService
        .listarAdheridos({ page: 0, size: 100 }, filter)
        .subscribe({
          next: (response: any) => {
            this.adheridoArray = response?.datos;
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  comboEstados() {
    this.AportacionDIEstadoControllerService.findAll14().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoArray = data?.filter((item) => item.id !== 4 && item.id !== 1 && item.id !== 6) || [];
      },
      error: () => { },
    });
  }
  comboEstadosAdherido(){
    this.attachedService.getEstadosAdheridos().subscribe({
      next: (data: any) => {
        this.estadoArrayAdherido = data.content.filter((item: any) => item.id === 6 || item.id === 7 || item.id === 9) || [];
      },
      error: () => {},
    });
  }
  comboEstadosGestor() {
    this.gestorEstadoControllerService.findAll9().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoGestorArray = data || [];
      },
      error: () => {},
    });
  }
  comboCodigoLer() {
    // Módulo SDDR Cerrado (adheridos): solo códigos LER habilitados para SDDR CC
    const filter: CodigoLerFilterDTO = { sddrCC: true };
    this.codigoLerControllerService.findAll4(filter, { page: 0, size: 100 }).subscribe({
      next: (data: any) => {
        this.codigoLerArray = data.datos || [];
      },
      error: () => { },
    });
  }
  comboOperacionGestion() {
    const filter: any = {}
    this.operacionGestionControllerService.findAll7(filter, { page: 0, size: 100 }).subscribe({
      next: (data: any) => {
        this.operacionGestionArray = data.datos || [];
      },
      error: () => { },
    });
  }
  comboPlataformaOrigen() {
    this.plataformaOrigenControllerService.findAll6().subscribe({
      next: (data: Array<PlataformaOrigenDTO>) => {
        this.plataformaOrigenArray = data!;
      },
      error: () => { },
    });
  }
  comboOrden() {
      this.diccionarioControllerService.listarElementos(['ORDEN_SDDR_CERRADO_APORTACIONES_DI_FS_BUSQUEDA']).subscribe({
      next: (data: any) => {
        this.orden = data['ORDEN_SDDR_CERRADO_APORTACIONES_DI_FS_BUSQUEDA'];
      },
      error: () => { },
    });
  }
  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openHolderManagerSelection(adheridos: any, cargaMasiva: boolean, esMultipleDI?: boolean) {
    const dialogRef = this.dialog.open(ManagerSelectionDialogComponent, {
      width: '950px',
      maxWidth: '98%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        adheridoArray: adheridos,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(!cargaMasiva){
        this.openModalContributions(cargaMasiva,esMultipleDI,result);
        }else if(cargaMasiva) {
            const dialogRef = this.dialog.open(AttachedContributionsDisUploadDialogComponent, {
                width: '950px',
                maxWidth: '98%',
                maxHeight: '95vh',
                data: {
                  adherido: result.adherido,
                  esMultipleDI: esMultipleDI
                },
                disableClose: true,
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.searchData();
              }
            });
          }
      }
    });
  }

  openModalContributions(cargaMasiva: boolean, esMultipleDI?: any, element?: any) {
    if (!element) {
      if (this.adheridoArray?.length > 0) {
        if (this.adheridoArray?.length === 0) {
          this.snackBarSrv.showSnackBar(
            'No puede crear una Aportación DI/FS porque no tiene ningún Adherido en estado Completado.',
            'error'
          );
        }
        if (this.adheridoArray?.length > 1) {
          this.openHolderManagerSelection(this.adheridoArray, cargaMasiva, esMultipleDI );
        } else {
          if(!cargaMasiva){
          this.openModalContributions(!cargaMasiva,
            esMultipleDI, {
            adherido: {
              id: this.adheridoArray[0].id,
            },
            estado: { id: 1, descripcion: 'Abierta' },
          });
        }else if(cargaMasiva) {
          const dialogRef = this.dialog.open(AttachedContributionsDisUploadDialogComponent, {
                width: '950px',
                maxWidth: '98%',
                maxHeight: '95vh',
                data: {
                  adherido: this.adheridoArray[0]?.id,
                  esMultipleDI: esMultipleDI
                },
                disableClose: true,
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.searchData();
              }
            });
          }
        }
      }
    } else {
      const dialogRef = this.dialog.open(ContributionsDisDialogComponent, {
                width: '1300px',
                maxWidth: '98%',
                maxHeight: '95vh',
                data: element,
                disableClose: true,
              }
            );

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.searchData();
              }
            });
          }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('adheridos-di', 'view');
    const resultDelete = this.authService.can('adheridos-di', 'delete');

    const resultSend = this.authService.can('adheridos-di', 'update-send');
    const resultAccept = this.authService.can('adheridos-di', 'update-accept');
    const resultCancel = this.authService.can('adheridos-di', 'update-cancel');

    const listPermission = list?.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1;
      const estado2 = objeto.estado && objeto.estado.id === 2;
      const estado3 = objeto.estado && objeto.estado.id === 3;
      const estado5 = objeto.estado && objeto.estado.id === 5;
      const estado7 = objeto.estado && objeto.estado.id === 7;
      const estado8 = objeto.estado && objeto.estado.id === 8;
      const estado9 = objeto.estado && objeto.estado.id === 9;
      const estado10 = objeto.estado && objeto.estado.id === 10;
      objeto.fechaMAceptacion =
        objeto.fechaAceptacion != null
          ? moment(new Date(objeto.fechaAceptacion)).format('DD/MM/YYYY')
          : null;
      objeto.fechaMAportacion =
        objeto.fechaAportacion != null
          ? moment(new Date(objeto.fechaAportacion)).format('DD/MM/YYYY')
          : null;
      let descripcionMCodLer =
        objeto.codigoLer !== null && objeto.codigoLer !== undefined ? `${objeto.codigoLer.tipoCodigo} ${objeto.codigoLer.descripcion}` : '';
      let descripcionOperacionGes =
        objeto.operacionGestion !== null && objeto.operacionGestion !== undefined ? `${objeto.operacionGestion.codigo} ${objeto.operacionGestion.descripcion}` : '';
      const hasDocument = objeto.documento ? true : false;
      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete:
          resultDelete &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessSend:
          resultSend &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessAccept: resultAccept && (estado8 || estado5 || estado9 || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora())),
        canAccessCancel: resultCancel && (estado3 || estado7 || estado8 || estado9 || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora())),
        canAccessPreview: hasDocument,
        descripcionMCodLer: descripcionMCodLer,
        descripcionOperacionGes: descripcionOperacionGes,
        canAccessCorreccionEnvalora: (estado8 ||estado3) && this.puedeEditarAportacionEstadoCorrecionEnvalora()
      };
    });

    return listPermission;
  }

  canAccessNuevoDis(): boolean {
    return this.authService.can('adheridos-di', 'create');
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  sortGrid(element: any) {
    let colName = element.name;
    if (colName != null && colName != undefined && colName == 'fechaMAceptacion') {
      colName = 'fechaAceptacion';
    }
    if(colName != null && colName != undefined && colName == 'fechaMAportacion'){
      colName = 'fechaAportacion';
    }
    this.currentSort = `${colName},${element.type}`;
    this.pageNumber = 0;
    this.searchData();
  }
  openModalMotivoCancel(item:any){
    const dialogRef = this.dialog.open(
      ContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }
    
  vistaPreviaAportacion(element:any){
    const dialogRef = this.dialog.open(ContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }

    onInput(controlName: string, event: any) {
    const control = this.searchForm.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }

    canAccessCargaMasivaDis(): boolean {
      return this.canAccessNuevoDis() && (this.gestoresArray?.filter((item:any) => item.cargaMasiva).length > 0 || this.codigoDocumentoAdheridoArray?.filter((item:any) => item.cargaMasiva).length > 0);
    }

  puedeEditarAportacionEstadoCorrecionEnvalora(){
    return this.canViewResource('SDDR-CC-APORT-EDIC-TOTAL-ENV-GEST');
  }

}
